var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3671741_cloud_upload_icon 1",
    clipPath: "url(#clip0_0_13442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.888 23.66C46.3791 24.2277 48.5741 25.6925 50.0542 27.7751C51.5344 29.8576 52.1961 32.4121 51.9133 34.9514C51.6304 37.4906 50.4228 39.8369 48.5206 41.5427C46.6185 43.2485 44.155 44.1944 41.6 44.2H13C9.77616 44.2032 6.66608 43.0085 4.27357 40.8476C1.88105 38.6868 0.37678 35.714 0.0527844 32.5065C-0.271211 29.2989 0.608182 26.0854 2.52025 23.4898C4.43231 20.8941 7.24063 19.1015 10.4 18.46V18.2C10.3984 16.8249 10.7603 15.4739 11.4491 14.2837C12.1378 13.0936 13.129 12.1067 14.3221 11.423C15.5152 10.7394 16.8678 10.3833 18.2428 10.3908C19.6179 10.3984 20.9665 10.7693 22.152 11.466C23.9765 9.66332 26.2952 8.44307 28.8141 7.96003C31.333 7.47699 33.9386 7.75291 36.3004 8.7528C38.6623 9.7527 40.674 11.4315 42.0804 13.5763C43.4868 15.7211 44.2245 18.2353 44.2 20.8C44.2 21.788 44.096 22.724 43.888 23.66ZM28.6 28.6H36.4L26 18.2L15.6 28.6H23.4V36.4H28.6V28.6Z",
    fill: "#1B80E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_13442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudupload);
export default __webpack_public_path__ + "static/media/cloudupload.9960ad42c2cc02dc349fcbe1661a1e0c.svg";
export { ForwardRef as ReactComponent };